import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import api from '@/api'
import router from '@/router'
import {
	Notification,
	Message
} from 'element-ui'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		messageList: [], // 消息列表
		messagePage: 1, // 消息当前页码
		messageTotal: 1, // 消息总条数
		msgUnReadCount: 0, // 消息未读数
		websocket: null
	},
	mutations: {
		// 获取消息列表
		setMessageList(state, data) {
			state.messageList = data.data
			state.messagePage = data.page
			state.messageTotal = data.total
		},

		// 获取消息未读数
		getMessageUnReadCount(state) {
			api.home.messageUnReadCount().then(({
				data
			}) => {
				if (data.code == 200) {
					state.msgUnReadCount = data.data
				}
			})
		},

		// 消息提醒socket
		openWebsocket(state, uid) {
			// 判断当前浏览器是否支持WebSocket
			if ('WebSocket' in window) {
				if (state.websocket) {
					state.websocket.close()
					state.socket = null
				}

				state.websocket = new WebSocket(
					`ws://workda.wuerp.com:8885/webscoket/${uid}`
				) // 后台给的地址

				// 连接成功建立的回调方法
				state.websocket.onopen = () => {
					// console.log('WebSocket连接成功')
				}

				// 连接发生错误的回调方法
				state.websocket.onerror = () => {
					// console.log('WebSocket连接发生错误')
				}

				// 接收到消息的回调方法
				state.websocket.onmessage = event => {
					if (event.data == '连接成功') return
					let data = {}
					if (event.data) data = JSON.parse(event.data)
					if (data.messageType == '1') {
						// console.log('接收到消息', data)
						state.msgUnReadCount++ // 未读数+1
						// 重新获取消息列表--延迟500ms因为马上获取数据 后端有数据还没准备好
						setTimeout(() => {
							this.dispatch('getMessageList', state.messagePage)
						}, 1000)
						// 弹出消息通知
						Notification({
							title: data.title,
							type: 'info',
							message: data.message,
							onClick: async () => {
								// 读消息
								const res = await api.home.messageRead(data.messageId)
								if (res.data.code === 200) this.dispatch('getMessageList', state
									.messagePage)

								if(data.msgType == 'text'){
									return;
								}
								// 进去详情
								router.push({
									path: '/workOrderDetail',
									query: {
										id: data.sheetId
									}
								})
							}
						})
					}
				}

				// 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
				window.onbeforeunload = () => {
					state.websocket.close()
				}
			} else {
				Message({
					message: '当前浏览器不支持WebSocket',
					type: 'error'
				})
			}
		}
	},
	actions: {
		getMessageList({
			state,
			commit
		}, page) {
			return new Promise((resolve, reject) => {
				api.home
					.messageList({
						limit: 10,
						page: page || state.messagePage || 1
					})
					.then(({
						data
					}) => {
						if (data.code == 200) {
							data.page = page || 1
							commit('setMessageList', data)
						}
						resolve()
					})
			})
		}
	},
	modules: {
		app,
		user
	}
})
